import _ from 'lodash'

import { sanitizeEmbedHtml, sanitizeHtml } from '@/shared/lib/html/sanitize'


export const LevelPlaySlide = ({ activity, step }) => {
  const { meta } = activity
  const slides = meta?.slides || []
  const currentSlide = slides[step.slideIndex]
  const { kind, image, iframe, text } = currentSlide

  return (
    <div className="animate-fade-in flex flex-col">
      {kind == 'image' && (
        <div className="aspect-video w-full mb-10">
          <img
            src={_.get(image, 'file.url')}
            alt=""
            className="w-full block object-cover object-center rounded-xl"
          />
        </div>
      )}
      {kind == 'iframe' && (
        <div
          className="aspect-video w-full mb-10"
          dangerouslySetInnerHTML={{ __html: sanitizeEmbedHtml(iframe) }}
        />
      )}
      <span
        className="text-gray-800 text-lg md:text-base [&_img]:w-full [&_img]:block"
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(text) }}
      />
      <span className="w-full pb-20 block"></span>
    </div>
  )
}
